import { render } from "./BackupRestore.vue?vue&type=template&id=4ae28ccb"
import script from "./BackupRestore.vue?vue&type=script&lang=js"
export * from "./BackupRestore.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__